export default {"src":"/_next/static/media/VE_ICON.c1dd85a8.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};